import JobArrow from '../JobArrow';
import styles from './index.module.scss';

export type JobCardProps = {
  title: string;
  tags: string[];
  link: string;
};

export default function JobCard({ title, tags, link }: JobCardProps) {
  const openJob = () => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  return (
    <div className={styles.card} onClick={openJob}>
      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.tags}>
          {tags.map((tag) => (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      </div>
      <JobArrow className={styles.arrow} />
    </div>
  );
}
